import { EmailOutlined, Facebook, GitHub, Instagram, LocalPhoneOutlined, LocationOnOutlined, WhatsApp } from '@material-ui/icons';
import React from 'react';

const Footer = () => {
  return (
    <div className="flex items-center justify-around p-2 mobile:flex-col mobile:items-start">
      <div className="flex flex-1 flex-col flex-wrap p-2">
        <h1 className="text-2xl">Iwan Plamboyan</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur magnam laborum iure dolorum! Quae ipsa illo sapiente quis eveniet voluptatum consectetur corporis alias, dolor aliquid accusantium odit. Nisi, esse optio!</p>
        <div className="flex justify-center item-center mt-3 self-start">
          <div className="m-3 rounded-full cursor-pointer p-2 text-white bg-orange-500">
            <Instagram />
          </div>
          <div className="m-3 rounded-full cursor-pointer p-2 text-white bg-blue-700">
            <Facebook />
          </div>
          <div className="m-3 rounded-full cursor-pointer p-2 text-white bg-[#171515]">
            <GitHub />
          </div>
          <div className="m-3 rounded-full cursor-pointer p-2 text-white bg-[#25D366]">
            <WhatsApp />
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-2 gap-6">
        <div className="flex">
          <LocationOnOutlined />
          <p className="pl-3">State of Indonesia</p>
        </div>
        <div className="flex">
          <LocalPhoneOutlined />
          <p className="pl-3">+62 00000000000</p>
        </div>
        <div className="flex">
          <EmailOutlined />
          <p className="pl-3">iwanplam03@gmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
